'use es6';

import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import env from 'enviro';
import partial from 'transmute/partial';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
const add = (type, message, messageOptions = {}, ...alertOptions) => {
  if (!I18n.lookup(message) && messageOptions._defaultMessage && I18n.lookup(messageOptions._defaultMessage)) {
    message = messageOptions._defaultMessage;
  }
  if (I18n.lookup(message)) {
    message = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: message,
      options: messageOptions
    });
  } else if (!env.deployed()) {
    console.warn('Alert key not translated: ', message);
    if (messageOptions._defaultMessage) {
      console.warn('Alert default key not translated: ', messageOptions._defaultMessage);
    }
  }
  FloatingAlertStore.addAlert(Object.assign({
    message,
    type,
    'data-alert-type': type
  }, ...alertOptions));
};
export const addAlert = (...args) => FloatingAlertStore.addAlert(...args);
export const addError = partial(add, 'danger');
export const addWarning = partial(add, 'warning');
export const addSuccess = partial(add, 'success');
export const addDanger = partial(add, 'danger');